module.exports = __webpack_public_path__ + "img/service.aac632df.png";